import { ExecutionStatus, ScenarioStatus, WorkflowSchedule } from "./types";

export const formatWorkflowDate = (value?: string | null): string => {
    if (!value) {
        return '—';
    }
    const date = new Date(value);

    return isNaN(date.getTime()) ? value : date.toLocaleString();
};

// The theme's soft badges (components/_badge.scss). Bootstrap 5.2 has no bg-*-subtle classes.
export const SCENARIO_STATUS_CLASS: Record<ScenarioStatus, string> = {
    draft: 'badge-soft-secondary',
    active: 'badge-soft-success',
    paused: 'badge-soft-warning',
    disabled_by_error: 'badge-soft-danger',
};

export const EXECUTION_STATUS_CLASS: Record<ExecutionStatus, string> = {
    queued: 'badge-soft-secondary',
    running: 'badge-soft-info',
    waiting: 'badge-soft-primary',
    success: 'badge-soft-success',
    warning: 'badge-soft-warning',
    error: 'badge-soft-danger',
    cancelled: 'badge-soft-secondary',
};

export const isFinalExecution = (status: ExecutionStatus) => ['success', 'warning', 'error', 'cancelled'].includes(status);

/** A one-line summary of a schedule, for the list and the editor toolbar. */
export const describeSchedule = (schedule: WorkflowSchedule | null | undefined, t: (key: string, options?: any) => string): string => {
    if (!schedule) {
        return t('workflow:notScheduled');
    }
    switch (schedule.type) {
        case 'interval':
            return t('workflow:everyMinutes', { minutes: schedule.interval });
        case 'daily':
            return t('workflow:dailyAt', { time: schedule.time });
        case 'weekly':
            return t('workflow:weeklyAt', { days: (schedule.days || []).map((d) => t('workflow:weekday_' + d)).join(', '), time: schedule.time });
        case 'monthly':
            return t('workflow:monthlyAt', { days: (schedule.days || []).join(', '), time: schedule.time });
        case 'once':
            return t('workflow:onceAt', { date: formatWorkflowDate(schedule.date) });
        case 'cron':
            return 'cron: ' + (schedule.expression || '');
        default:
            return t('workflow:schedule_' + schedule.type);
    }
};
